export const SESSION_MAX_AGE = 530;
